import { zergApi } from "@/service/zerg";

class AreasModuleService {

    async getAreasModule(){
        try {
            const data = await zergApi.get("setting/areas-module/get");
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async getAreas(){
        try {
            const data = await zergApi.get("setting/areas-module/get-areas");
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async saveData(params){
        try {
            await zergApi.post("setting/areas-module/save-data", params);
        } catch (error) {
            console.log(error)
        }
    }

    async getTracking(params){
        try {
            const data = await zergApi.post("setting/areas-module/get-tracking", params);
            return data
        } catch (error) {
            console.log(error)
        }
    }
}

export default new AreasModuleService();